<script>
import ModelEdit from '../models/edit';
import FormsModel from "@/components/forms/trip-edit";
import {serialize} from "object-to-formdata";
import Swal from "sweetalert2";
import {hasAllowedAction as hasAllowedActionHelper} from "@/helpers/ui/allowedActions";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit Trips",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('trips.singular')) }},
    resourceRoute: {default: 'trips'},
    modelVariable: {default: 'trip'},
    denyDelete: {default(){return this.denyDelete}},
    form: {default() { return FormsModel; }},
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('trips.plural'))
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t('trips.plural')),
          href: "/trips",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/trips/${this.$route.params.key}`,
          active: true,
        },
        {
          text: this.$t('Edit'),
          href: `/trips/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    canEditModel(model = this.model) {
      return hasAllowedActionHelper(model, ["edit", "update"]);
    },
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/trips/${this.$route.params.key}`, {
        params: {
          // customer,shrimp,purchase_items.purchase_order.farmer,purchase_items.purchase_order.shrimp
          with: [
            'trip_items.purchase_order.product',
            'trip_items.purchase_order.farmer',
            'trip_items.purchase_order.customer',
            'trip_items.purchase_order.product',
            'trip_items.purchase_order.purchase_items.purchase_order.farmer',
            'trip_items.purchase_order.purchase_items.purchase_order.product',
            'trip_items.purchase_item',
            'files',
            'ticket.trips.trip_items.purchase_order.product',
            'ticketable',
            'sale_orders',
            'creator',
          ].join(','),
        }
      }).then((response) => {
        const { data: { data } } = response;
        const trips = data.ticket.trips.filter((trip => (new Date(trip.created_at) >= new Date(data.created_at))))
        this.model = {
          ...data,
          files: !data.files.length ? [{}]:  data.files.map((v) => {
            let file = { ...v, preview: v.url, format: v.extension}
            delete file.path
            return file
          }),
          purchase_order_id: (data.trip_items.map(item => item.purchase_order?.id)),
          purchase_order_ids: `${(data.trip_items.map(item => item.purchase_order?.id)).join()},`,
          purchase_order_selected: data.trip_items.map(item => item.purchase_order),
          trip_items: data.trip_items.map(function (item) {
            return {
              ...item,
              purchase_order_id: item.purchase_order?.id,
              fund: item.purchase_item.fund,
              quality: item.purchase_item.quality,
            }
          }),
          initial_trip_items: data.trip_items.map(function (item) {
            return {
              ...item,
              purchase_order_id: item.purchase_order?.id,
              fund: item.purchase_item.fund,
              quality: item.purchase_item.quality
            }
          }),
          paymentable: {ticketable: {ticket_id: data.trip_items?.[0]?.purchase_order?.ticket_id}},
          selected_purchase_orders: data.trip_items.map(item => item.purchase_order),
          initial_purchase_orders: data.trip_items.map(item => item.purchase_order),
          // purchase_items: data.trip_items.map(item => item.purchase_order),
          purchase_items: [],
          // filter where each trip.created_at > model.created_at
          trips,
          tripped_at: data.tripped_at ? data.tripped_at.split('T')[0] : null,
          has_trip_item: !!data.trip_items.length
        };
        if (data.sale_orders.length > 0) {
          this.denyDelete = true
        }

        if (!this.canEditModel(this.model)) {
          window.location.href = `/trips/${this.$route.params.key}`;
        }

        return response;
      }).catch((error) => this.failedAlert(error)).finally(() => this.loading = false)
    },
    update(value) {
      const deletedTripItems = this.model.initial_trip_items.filter((item) => {
        return !this.model.trip_items.some((tripItem) => tripItem.id === item.id)
      }).map((item) => ({
        ...item,
        _action: 'delete'
      }))
      value = {
        files: value.files.filter(v => typeof v.file !== 'string').map(v => ({...v, path: v.file})),
        driver_id: value.driver_id,
        vehicle_id: value.vehicle_id,
        invoice_number: value.invoice_number,
        tripped_at: value.tripped_at,
        total_price: value.trip_items.reduce((total, v) => total + (v.total_price || 0), 0),
        description: value.description,
        trip_items: [...value.trip_items, ...deletedTripItems],
        ticketable: value.ticketable,
        customer_id: value.customer_id,
      }
      return this.$axios.post(`/trips/${this.$route.params.key}`, (
          serialize({...value, _method:'PUT'}, { indices: true,booleansAsIntegers: true})
      ))
    },
    delete() {
      return this.$axios.delete(`/trips/${this.$route.params.key}`)
    },
    confirmationModal(differenceQuantity, purchaseOrderIds) {
      let differenceSentence = `Selisih biomassa Nota Panen dengan Nota Armada sebanyak <b>${this.$numeral(differenceQuantity).format('0,0.[00]')}</b> kg.`
      let confirmSentence = `Apakah Anda ingin menyimpan dan selisih biomassa dari nota panen ${purchaseOrderIds} dibuatkan nota armada baru?`

      return Swal.fire({
        title: `${confirmSentence}`,
        html: `<span style="font-size: 14px">*${differenceSentence}</span>`,
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Ya, Simpan dan Buatkan Nota Armada Baru',
        confirmButtonColor: '#0084F3',
        cancelButtonText: 'Batal',
      })
    },
    handleEditAndUpdate(value) {
      this.updating = true
      this.update(value).then(() => {
        this.updateSuccessAlert({
          something: this.$t('trips.singular'),
        })
      }) .then(() => {
        const tripItems = value.purchase_items.map(purchaseItem => {
          let tripItem = value.trip_items.find(trip_item => trip_item.purchase_item_id === purchaseItem.id)
          let availableQuantity = (purchaseItem.available_quantity || 0) - ((tripItem || {}).quantity || 0)

          return {
            ...tripItem,
            quantity: availableQuantity,
            max_quantity: availableQuantity,
          }
        }).filter(purchaseItem => purchaseItem.quantity > 0)
        let trip = {
          ticketable: value.ticketable,
          purchase_order_id: value.purchase_order_id,
          trip_items: tripItems,
        }
        localStorage.setItem('createTripAgain', JSON.stringify(trip))
      }).then(() => {
        this.isEditing = false
        return this.$router.push('/trips/create')
      }).catch((error) => this.failedAlert(error))
          .finally(() => {
            this.updating = false
          })
    },
    handleUpdate(value) {

      if (value.difference > 0 && value.isTripItemChanged) {
        let purchaseOrderIds = value.selected_purchase_orders.map(v => v.id).join(', ').replace(/,(?!.*,)/gmi, ` ${this.$t('and')}`)
        this.confirmationModal(value.difference, purchaseOrderIds)
            .then((response) => {
              if (response.isConfirmed) return this.handleEditAndUpdate(value)
            }).catch((error) => {
          this.failedAlert(error)
          this.updating = false
        })
      } else {
        // throw new Error(value.difference);
        return this.handleUpdateAndBack(value)
      }
    },
    handleStoreSaleOrder(value){
      this.updating = true;
      this.storeSaleOrder(value)
          .then((response) => {
            this.updating = false;
            if (localStorage.getItem('createTripAgain')) {
              localStorage.removeItem('createTripAgain')
            }
            this.$router.push({path: `/lcm/${response.data.data.id}/edit`});
          })
          .catch((error) => {
            this.failedAlert(error);
          })
          .finally(() => {
            this.updating = false;
          });
    },
    storeSaleOrder(value) {
      const saleItems = value.purchase_items.filter(purchaseItem => purchaseItem.$checkbox && purchaseItem.fund !== "kmtb").map(purchaseItem => {
        let tripItem = value.trip_items.find(trip_item => trip_item.purchase_item_id === purchaseItem.id)
        let availableQuantity = (purchaseItem.available_quantity || 0) - ((tripItem || {}).quantity || 0)
        let saleItem = {
          ...purchaseItem,
          purchase_item_id: purchaseItem.id,
          quantity: availableQuantity,
          max_quantity: availableQuantity,
          total_price: availableQuantity * purchaseItem.unit_price,
          product_id: purchaseItem.product_id,
          initial_quantity: availableQuantity,
          initial_size: purchaseItem.size,
        }
        delete saleItem.id
        return saleItem
      }).filter(purchaseItem => purchaseItem.quantity > 0)
      const saleOrder = {
        ordered_at: value.tripped_at,
        total: saleItems.reduce((total, saleItem) => total + (saleItem.total_price || 0), 0),
        sale_items: saleItems,
        type: 'local_market',
        ticketable: value.ticketable,
      };
      return this.$axios.post('/sale_orders', (
          serialize({...saleOrder}, {indices: true, booleansAsIntegers: true})
      ));
    },
    handleUpdateAndBack(value) {
      this.updating = true;
      this.update(value)
          .then(() => {
            this.updateSuccessAlert({
              something: this.$t('trips.singular'),
            })
          })
          .then(() => {
            this.isEditing = false;
            if (localStorage.getItem('createTripAgain')) {
              localStorage.removeItem('createTripAgain')
            }
            return this.$router.push('/trips')
          })
          .catch((error) => this.failedAlert(error))
          .finally(() => {
            this.updating = false
          })
    },
    updateSuccessAlert(something) {
      return Swal.fire({
        title: this.$t('Success') + '!',
        text: this.$t(`You've updated {something} with id {id} `, { something: something.something, id: this.model.id }),
        type: 'success',
        showConfirmButton: false,
        timer: 1500
      })
    },
    onStoreSuccess(value){
      return this.storeSuccessAlert(`Nota Armada dengan ID ${this.getModelName(value)}`)
    },
  }
}
</script>
